import { APP_NAV_SECTIONS } from "utils/constants/core";
export const getUserAppNavSections = (accountType, permissions = [], businessPermissions = []) => {
    return APP_NAV_SECTIONS.filter((x) => {
        if (x.route == '/settings' || x.route == '/memberships' || x.route == '/staffs' || x.route == 'dashboard') {
            return false;
        }


        return (
            true
        );
    });
}